import React from "react";
import PropTypes from "prop-types";
import AnimateHeight from "react-animate-height";

const noop = x => x;

const Collapse = ({
  expand = false,
  minHeight = "0px",
  children,
  onAnimationStart = noop,
  onAnimationEnd = noop,
  ...props
}) => {
  const height = expand ? "auto" : parseInt(minHeight);
  return /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement(AnimateHeight, {
    onAnimationStart: onAnimationStart,
    onAnimationEnd: onAnimationEnd,
    duration: 80,
    easing: expand ? "ease-in" : "ease-out",
    height: height
  }, children));
};

Collapse.propTypes = {
  /** Content that can be collapsed */
  children: PropTypes.node.isRequired,

  /** Whether the content is collapsed */
  expand: PropTypes.bool,

  /** The minimum height (in pixels) of the content when collapsed */
  minHeight: PropTypes.string,

  /** Callback after animation starts */
  onAnimationStart: PropTypes.func,

  /** Callback after animation finishes */
  onAnimationEnd: PropTypes.func
};
export default Collapse;